module.exports = __webpack_public_path__ + "static/img/rank-bg.ccd18388.png";